import { faInfo } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Modal, TextField, Tooltip } from '@mui/material';
import { DataGrid, GridColDef, GridColumnHeaderParams, GridRenderCellParams, GridRowProps } from '@mui/x-data-grid';
import React, { ChangeEvent, useState } from 'react'
import * as XLSX from 'xlsx';
import { divisionBulkUploadMapping } from '../../features/roleDivision/RoleDivisionMapping';
import { ChannelkartNetworkPost } from '../../services/networkService';
import { popupType } from '../../types/types';
import './DivisionBulkUpload.css'
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';

type DivisionBulkUploadPropTypes = {
  openPopup: (message: string, type: popupType) => void,
}

interface fileType {
  fileName: string,
  data: Object[]
}

function DivisionBulkUpload(props: DivisionBulkUploadPropTypes) {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT = "Division"
  const CUR_COMPONENT_COMMON="commonPortal";
  const [videoPlayed, toggleVideoPlayed] = useState(false);
  const [bulkUploadRows, setBulkUploadRows] = useState<Object[]>([]);
  const [failuresCount, setFailuresCount] = useState<number>(0)
  const [file, setFile] = useState<fileType>({
    fileName: '',
    data: [],
  })


  var displayName = ["admin", "report admin", "asm", "supplier", "sales rep.", "retailer"];

  function validateDivisionData(data: any) {
    if (data && data.length > 0) {
      let tempFailureCount = 0;
      data.map((element: any) => {
        element['reason'] = [];
        if (!element['userhierarchy']) {
          element['reason'].push('User hierarchy must not be empty');
        }
        if (!element['displayname']) {
          element['reason'].push('Display name must not be empty');
        } else if (displayName.indexOf(element['displayname']) == -1) {
          element['reason'].push('Display name must be one of those ' + displayName);
        }
        if (!element['permissiongroups']) {
          element['reason'].push('Permission groups must not be empty');
        }
        var ch = '' + element['ischannel'];
        if (ch != '' && ch != 'TRUE' && ch != 'true' && ch != 'FALSE' && ch != 'false') {
          element['reason'].push('Ischannel column must have either (true,false)');
        }
        tempFailureCount = tempFailureCount + 1;
      });
      setFailuresCount(tempFailureCount);
      return data;
    } else {
      props.openPopup("Looks like you have uploaded empty sheet. Please choose correct sheet.", "Error");
      return [];
    }
  }


  function resetFileInput() {
    const fileInput = document.querySelector('.bulk_upload_input') as HTMLInputElement; // Cast the element as HTMLInputElement
    fileInput.value = ''; // Reset the input field by setting its value to an empty string
  }

  const handleFileInput = (event: ChangeEvent<HTMLInputElement>) => {
    const inputFile = event.target.files?.[0];
    if (inputFile) {
      let reader = new FileReader()
      reader.readAsArrayBuffer(inputFile);
      reader.onload = (e) => {
        //here
        if (e.target != null) {
          const data = e.target.result;
          let wb = XLSX.read(data);
          if (wb.SheetNames.length == 0) {
            return;
          }
          let sheet0 = wb.SheetNames[0];
          let jsonData: Object[] = XLSX.utils.sheet_to_json(wb.Sheets[sheet0], { range: 2 },);
          setFile(
            {
              fileName: inputFile.name,
              data: jsonData,
            }
          )
          setBulkUploadRows(jsonData);
          if (validateDivisionData(jsonData).length != 0) {
            setBulkUploadRows(jsonData);
          }
        }
      }

    }

  };

  const columns: GridColDef[] = divisionBulkUploadMapping.columns.map(
    (columnsMetaData) => {
      return {
        disableColumnMenu: true,
        field: columnsMetaData.mappedValue,
        headerName: columnsMetaData.headerName,
        sortable: false,
        // width:200,
        minWidth: (columnsMetaData.mappedValue === 'reason') ? 900 : 200,
        flex: 1,
        headerAlign: "left",
        align: "left",
        renderHeader: (params: GridColumnHeaderParams) => (
          <Tooltip title={columnsMetaData.headerName}>
            <b>{columnsMetaData.headerName}</b>
          </Tooltip>
        ),
      };
    }
  );


  const excelupload = async () => {
    try {
      const response = await ChannelkartNetworkPost("/v1/divisions?transformer=Division", file?.data)
      if (response.status == 201) {
        resetFileInput();
        props.openPopup('Data Saved!', 'Success')
      } else {
        props.openPopup('Something went wrong while saving data through excel sheet!', 'Error')
      }
    } catch (error) {
      props.openPopup('Something went wrong while saving data through excel sheet!', 'Error')
      console.log('error occured:', error)
    }
  }

  return (
    <div>

      <div className='bulk_upload_container'>
        <div className='bulk_upload_heading'>
          {translate(TranslationEnum.division,"Upload Master Excel")}
          <FontAwesomeIcon id='info_icon' icon={faInfo} onClick={() => { toggleVideoPlayed(true) }} />

        </div>
        {/* <div className='bulk_upload_body'>
          <input type="file" accept='.xlsx' className='bulk_upload_input' onChange={handleFileInput} />
          <Button variant="contained" onClick={excelupload}>{translate(TranslationEnum.common_portal,"Upload")}</Button>

        </div> */}
        <div className='bulk_upload_body'>
          <input
            type="file"
            accept='.xlsx'
            className='bulk_upload_input'
            onChange={handleFileInput}
            id="customFileInput"
            style={{display:"none"}}
          />
          <label htmlFor="customFileInput" className='file_label'>
            <Button variant="contained" component="span">
              {translate(TranslationEnum.common_portal,"Choose File")}
            </Button>
          </label>
          <span className='file_name'>{file.fileName ? file.fileName : translate(TranslationEnum.common_portal,"No file chosen")}</span>
          <Button variant="contained" onClick={excelupload}>{translate(TranslationEnum.common_portal,"Upload")}</Button>
        </div>
        {file.data.length != 0 &&
          <>

            <div className='division_grid_title'>

              <div className='master_data_heading'>
                {file?.fileName}
              </div>
              <div className='division_search_field'>
                <TextField
                  id="outlined-basic"
                  label="Search"
                  variant="outlined"
                  size="small"
                  autoComplete="off"
                  onChange={(e) => {
                    const searchedData = e.target.value.toString().toLowerCase();
                    const finalData = file.data.filter((eachRow) => {

                      const allValues = Object.values(eachRow);
                      return allValues.find((eachValue: any) => {
                        return eachValue?.toString().toLowerCase().includes(searchedData);
                      });
                    })
                    setBulkUploadRows(finalData);
                  }}
                />
              </div>


            </div>




            <div className='division_management_grid'>
              <DataGrid
                disableRowSelectionOnClick={true}
                sx={{
                  "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
                    outline: "none !important",
                  },
                }}
                rows={bulkUploadRows ? bulkUploadRows : []}
                columns={columns}
                getRowId={(row: any) => row.loginid + row.name}
                autoHeight
              />
            </div>
          </>

        }
      </div>
      <Modal
        className='video_player_modal'
        open={videoPlayed}
        onClose={() => { toggleVideoPlayed(false) }}
      >
        <div className='video_player' >
          <video width="100%" height="80%" controls>
            <source src="https://docs.sellina.io/public/media/mdm/divisionmdm_panel2.mp4" type="video/mp4" />
            {translate(TranslationEnum.division,"Your browser does not support the video tag")}
          </video>
          <button className='video_close_button' onClick={() => toggleVideoPlayed(false)}> {translate(TranslationEnum.common_portal,"close")}</button>
        </div>

      </Modal>


    </div>
  )
}

export default DivisionBulkUpload